export default __webpack_public_path__ + "2ee4d343282f4b78ec82df171c724a37.png";